import Konva from "konva";
import { useEffect } from "react";

export const useMarchingBorder = (
  konvaRef: React.RefObject<Konva.Shape | null>,
  isActive = true,
) => {
  useEffect(() => {
    const shape = konvaRef.current;
    if (!shape || !isActive) return;
    const layer = shape.getLayer();

    const speedMult = 0.01;
    const anim = new Konva.Animation((frame) => {
      if (!frame) return;

      shape.dashOffset(shape.dashOffset() + frame.timeDiff * speedMult);
    }, layer);

    anim.start();

    return () => {
      anim.stop();
    };
  }, [konvaRef, isActive]);
};
